import(/* webpackMode: "eager" */ "/app/app/wine-dine/page.js");
